import { useCalendarContext } from '../../calendar-context'
import { Calendar } from '@/components/ui/calendar'

export default function CalendarBodyDayCalendar() {
  const { date, setDate, setMode } = useCalendarContext()
  return (
    <Calendar
      className=''
      selected={date}
      onSelect={(date: Date | undefined) => {
        setMode("day")
        date && setDate(date)
      }}
      mode="single"
    />
  )
}
